export const pickViolationInfoChecbox = (visitData, firstField, defaultField) => {
  if (!firstField) return defaultField;
  const fildValue = visitData?.attributes?.[firstField] || visitData?.attributes?.metadata?.[firstField] || [];
  if (!Array.isArray(fildValue)) return [fildValue];
  return fildValue;
};
